import { makeStyles } from 'tss-react/mui'

import { Theme } from '@mui/material'

export const useCorporateDataFormStyles = makeStyles()(({ palette, spacing }: Theme) => ({
  formContainer: {
    display: 'flex',
    gap: spacing(5),
  },
  formSection: {
    paddingBottom: spacing(5),
  },
  formUserSection: {
    paddingBottom: spacing(5),
    minHeight: spacing(50),
  },
  field: {
    width: '100%',
    marginBottom: spacing(2),
  },
  booleanFields: {
    marginTop: spacing(),
    display: 'flex',
  },
  inlineField: {
    marginRight: spacing(3),
    flex: '0 0 auto',
  },
  label: {
    position: 'relative',
  },
  dangerZone: {
    background: '#FADBD8',
    padding: spacing(2),
    marginBottom: spacing(2),
  },
  radarScouting: {
    width: '170px',
  },
  doubleFieldWrapper: {
    display: 'grid',
    gridGap: spacing(),
    gridTemplateColumns: '1fr 1fr',
    width: '100%',
  },
  linkWrapper: {
    gap: '10px',
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    height: 'auto',
    maxHeight: '200px',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  samplesWrapper: {
    gap: '.5rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
    display: 'flex',
  },
  termText: {
    minWidth: '300px',
    textOverflow: 'ellipsis',
    maxWidth: '300px',
    overflowX: 'auto',
  },
  hidden: {
    visibility: 'hidden',
  },
  generateSearchCandidatesContainer: {
    position: 'relative',
    display: 'inline-block',
  },
  buttonSuccess: {
    backgroundColor: palette.secondary.main,
    '&:hover': {
      backgroundColor: palette.secondary.dark,
    },
  },
  buttonProgress: {
    color: palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  copyIdButton: {
    marginRight: spacing(2),
  },
  isDeleted: {
    width: '300px',
  },
}))
